import React from 'react';
import kombucha from "../../assets/kombucha.webp";
import kombucha2 from "../../assets/kombuha2.webp"
import koia from "../../assets/koia.webp";
import cafe from "../../assets/caffee.webp";
import locion from "../../assets/locion.png";
import chocolate from "../../assets/chocolate.png";
import lentes from "../../assets/lentes.png";
import electrolito from "../../assets/leysure.jpg";

export default function Shop() {
  const productos = [
    {
      id: 1,
      nombre: "Kombucha de JuneShine",
      categoria: "Bebidas",
      descripcion: "Kombucha refrescante y saludable de JuneShine.",
      precio: 4.50,
      image: kombucha
    },
    {
      id: 3,
      nombre: "Bebidas proteicas de Koia",
      categoria: "Bebidas",
      descripcion: "Bebidas proteicas veganas y bajas en azúcar de Koia.",
      precio: 3.75,
      image: koia
    },
    {
      id: 4,
      nombre: "Electrolitos por hidratación de ocio",
      categoria: "Bebidas",
      descripcion: "Bebidas con electrolitos para una hidratación óptima durante el ocio.",
      precio: 2.99,
      image: electrolito
    },
    {
      id: 6,
      nombre: "Café por Boulevard",
      categoria: "Bebidas",
      descripcion: "Café de alta calidad tostado por Boulevard.",
      precio: 5.00,
      image: cafe
    },
    {
      id: 7,
      nombre: "Loción hidratante orgánica",
      categoria: "Cuidado personal",
      descripcion: "Loción hidratante hecha con ingredientes orgánicos.",
      precio: 12.00,
      image: locion
    },
    {
      id: 8,
      nombre: "Barra de chocolate oscuro",
      categoria: "Alimentos",
      descripcion: "Barra de chocolate oscuro con 85% de cacao.",
      precio: 3.25,
      image: chocolate
    },
    {
      id: 9,
      nombre: "Gafas de sol polarizadas",
      categoria: "Accesorios",
      descripcion: "Gafas de sol con lentes polarizadas para protección UV.",
      precio: 45.00,
      image: lentes
    },
    {
      id: 2,
      nombre: "Kombucha de JuneShine",
      categoria: "Bebidas",
      descripcion: "Kombucha refrescante y saludable de JuneShine.",
      precio: 4.50,
      image: kombucha2
    },
  ];

  return (
    <div className="w-full min-h-screen bg-cream">
      <div className="pt-32 pb-10">
        <h1 className="text-5xl font-bold text-mandarin text-center">Compras Adicionales</h1>
      </div>

      <div className="flex flex-wrap justify-center px-10 gap-8">
        {productos.map(product => (
          <div key={product.id} className="w-72 bg-white rounded-lg shadow-lg overflow-hidden transition-transform transform hover:scale-105">
            <img className="w-full h-64 object-contain p-4" src={product.image} alt={product.nombre} />
            <div className="p-6">
              <h2 className="text-xl font-semibold text-gray-800">{product.nombre}</h2>
              <p className="mt-2 text-sm text-gray-600">{product.descripcion}</p>
              <div className="mt-4 flex justify-between items-center">
                <span className="text-lg font-bold text-mandarin">${product.precio.toFixed(2)}</span>
                <button className="px-4 py-2 bg-mandarin text-white rounded-lg hover:bg-orange-600 transition-colors">
                  Añadir al carrito
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}